import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import('../components/Login.vue')
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: () => import('../components/backend/user/ListUser.vue')
        },
        {
            path: '/changeprofile',
            name: 'ChangeProfile',
            component: () => import('../components/backend/user/ChangeProfile.vue')
        },
        {
            path: '/updateusers/:id',
            name: 'AddUpdateUsers',
            component: () => import('../components/backend/user/AddUpdateUsers.vue')
        },
        {
            path: '/key/list',
            name: 'ListCalendarKey',
            component: () => import('../components/ListCalendarKey.vue')
        },
        {
            path: '/key/add',
            name: 'AddCalendarKey',
            component: () => import('../components/AddCalendarKey.vue')
        },
        {
            path: '/key/edit/:id',
            name: 'EditCalendarKey',
            component: () => import('../components/AddCalendarKey.vue')
        },
        {
            path: '/hrdragview',
            name: 'HRDragView',
            component: () => import('../components/backend/user/HRDragView.vue')
        },
        {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            component: () => import('../components/ListAttachmentGroup.vue')
        },
        {
            path: '/:type/add_attachment',
            name: 'AttachmentAddForm',
            component: () => import('../components/AttachmentAddForm.vue')
        },
        {
            path: '/:type/edit_attachment/:id',
            name: 'AttachmentEditForm',
            component: () => import('../components/AttachmentAddForm.vue')
        },
        {
            path: '/:type',
            name: 'CommonPage',
            component: () => import('../components/CommonPage.vue')
        },
        {
            path: '/forms/truckspecsandpricing',
            name: 'TruckSpecsandPricing',
            component: () => import('../components/TruckSpecsandPricing.vue')
        },
        // {
        //     path: '/:type/:group_id',
        //     name: 'ClickAttachmentGroup',
        //     // component: CommonPage
        //     component: () => import('../components/CommonPage.vue')
        // },
        {
            path: '/:type/test',
            name: 'CommonPageOld',
            component: () => import('../components/CommonPageOld.vue')
        },
        {
            path: '/:type/view',
            name: 'CommonPostDetail',
            component: () => import('../components/CommonPostDetail.vue')
        },
        {
            path: '/:type/add_post',
            name: 'DiscussionAddForm',
            component: () => import('../components/DiscussionAddForm.vue')
        },
        {
            path: '/:type/edit_post/:id',
            name: 'DiscussionEditForm',
            component: () => import('../components/DiscussionAddForm.vue')
        },
        {
            path: '/:type/add_date',
            name: 'EventAddForm',
            component: () => import('../components/EventAddForm.vue')
        },
        {
            path: '/:type/edit_date/:id',
            name: 'EventEditForm',
            component: () => import('../components/EventAddForm.vue')
        },
        {
            path: '/menu/add-edit-menu',
            name: 'AddEditMenu',
            component: () => import('../components/AddEditMenu.vue')
        },
        /*{
            path: '/user/list',
            name: 'UserList',
            // component: UserList
            component: () => import('../components/UserList.vue')
        },*/
        /* {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            // component: ListAttachmentGroup
            component: () => import('../components/ListAttachmentGroup.vue')
        }, */
        {
            path: '/attachment-group/add/:id',
            name: 'AddAttachmentGroup',
            component: () => import('../components/AddAttachmentGroup.vue')
        },
        {
            path: '/attachment-group/edit/:id',
            name: 'EditAttachmentGroup',
            component: () => import('../components/AddAttachmentGroup.vue')
        },
        {
            path: '/globalsearch/:searchText',
            name: 'GlobalSearchView',
            component: () => import('../components/GlobalSearchView.vue'),
            props: true
        },
        {
            path: '/:type/add_image',
            name: 'ImageAddForm',
            component: () => import('../components/ImageAddForm.vue')
        },
        {
            path: '/:type/edit_image/:id',
            name: 'ImageEditForm',
            component: () => import('../components/ImageAddForm.vue')
        },
        {
            path: '*',
            name: 'PageNotFound',
            component: () => import('../components/PageNotFound.vue')
        }
    ]
});
